// Auto-generated by tools/generate-atlases.js — do not edit
export default {
  "assets/icons/combat_test/character_attack.png": {
    "atlas": "assets/atlases/combat_test-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/combat_test/character_ready.png": {
    "atlas": "assets/atlases/combat_test-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/combat_test/goblin_attack.png": {
    "atlas": "assets/atlases/combat_test-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/combat_test/goblin_ready.png": {
    "atlas": "assets/atlases/combat_test-atlas.png",
    "x": 768,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/cooking/cooked_blueback.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/cooked_broadbill.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/cooked_crimson_char.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/cooked_mako.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 768,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/cooked_river_char.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 1024,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/cooked_sand_smelt.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 1280,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/cooked_silver_sprat.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 1536,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/cooked_skipjack.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 1792,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/cooked_spiny_lobster.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 0,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/empowered_blueback.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 256,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/empowered_broadbill.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 512,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/empowered_crimson_char.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 768,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/empowered_mako.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 1024,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/empowered_river_char.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 1280,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/empowered_sand_smelt.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 1536,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/empowered_silver_sprat.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 1792,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/empowered_skipjack.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 0,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/cooking/empowered_spiny_lobster.png": {
    "atlas": "assets/atlases/cooking-atlas.png",
    "x": 256,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeArmor/blackiron_chestplate.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/blackiron_gauntlets.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/blackiron_helm.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/blackiron_pauldrons.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 768,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/blackiron_platelegs.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1024,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/blackiron_sabatons.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1280,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/paleshard_chestplate.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1536,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/paleshard_gauntlets.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1792,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/paleshard_helm.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 0,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/paleshard_pauldrons.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 256,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/paleshard_platelegs.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 512,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/paleshard_sabatons.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 768,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/pyrestone_chestplate.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1024,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/pyrestone_gauntlets.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1280,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/pyrestone_helm.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1536,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/pyrestone_pauldrons.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1792,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/pyrestone_platelegs.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 0,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/pyrestone_sabatons.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 256,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/skyiron_chestplate.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 512,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/skyiron_gauntlets.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 768,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/skyiron_helm.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1024,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/skyiron_pauldrons.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1280,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/skyiron_platelegs.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1536,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/skyiron_sabatons.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1792,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/verdantcore_chestplate.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 0,
    "y": 768,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/verdantcore_gauntlets.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 256,
    "y": 768,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/verdantcore_helm.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 512,
    "y": 768,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/verdantcore_pauldrons.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 768,
    "y": 768,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/verdantcore_platelegs.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1024,
    "y": 768,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/verdantcore_sabatons.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1280,
    "y": 768,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/voidsteel_chestplate.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1536,
    "y": 768,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/voidsteel_gauntlets.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 1792,
    "y": 768,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/voidsteel_helm.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 0,
    "y": 1024,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/voidsteel_pauldrons.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 256,
    "y": 1024,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/voidsteel_platelegs.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 512,
    "y": 1024,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeArmor/voidsteel_sabatons.png": {
    "atlas": "assets/atlases/equipment-meleeArmor-atlas.png",
    "x": 768,
    "y": 1024,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1280
  },
  "assets/icons/equipment/meleeWeapons/blackiron_bulwark.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/blackiron_dirk.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/blackiron_greatsword.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/blackiron_sword.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 768,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/paleshard_bulwark.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 1024,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/paleshard_dirk.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 1280,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/paleshard_greatsword.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 1536,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/paleshard_sword.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 1792,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/pyrestone_bulwark.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 0,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/pyrestone_dirk.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 256,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/pyrestone_greatsword.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 512,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/pyrestone_sword.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 768,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/skyiron_bulwark.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 1024,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/skyiron_dirk.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 1280,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/skyiron_greatsword.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 1536,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/skyiron_sword.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 1792,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/verdantcore_bulwark.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 0,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/verdantcore_dirk.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 256,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/verdantcore_greatsword.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 512,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/verdantcore_sword.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 768,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/voidsteel_bulwark.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 1024,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/voidsteel_dirk.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 1280,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/voidsteel_greatsword.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 1536,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/meleeWeapons/voidsteel_sword.png": {
    "atlas": "assets/atlases/equipment-meleeWeapons-atlas.png",
    "x": 1792,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/equipment/rangedWeapons/shortbow.png": {
    "atlas": "assets/atlases/equipment-rangedWeapons-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/farming/crops/cabbage.png": {
    "atlas": "assets/atlases/farming-crops-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/crops/corn.png": {
    "atlas": "assets/atlases/farming-crops-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/crops/kings_fruit.png": {
    "atlas": "assets/atlases/farming-crops-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/crops/onion.png": {
    "atlas": "assets/atlases/farming-crops-atlas.png",
    "x": 768,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/crops/potato.png": {
    "atlas": "assets/atlases/farming-crops-atlas.png",
    "x": 1024,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/crops/starbloom.png": {
    "atlas": "assets/atlases/farming-crops-atlas.png",
    "x": 1280,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/crops/strawberry.png": {
    "atlas": "assets/atlases/farming-crops-atlas.png",
    "x": 1536,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/crops/tomato.png": {
    "atlas": "assets/atlases/farming-crops-atlas.png",
    "x": 1792,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/crops/watermelon.png": {
    "atlas": "assets/atlases/farming-crops-atlas.png",
    "x": 0,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/herbs/grimy_dusk_leaf.png": {
    "atlas": "assets/atlases/farming-herbs-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/farming/herbs/grimy_green_leaf.png": {
    "atlas": "assets/atlases/farming-herbs-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/farming/herbs/grimy_ironbloom.png": {
    "atlas": "assets/atlases/farming-herbs-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/farming/herb_seeds/ashbloom_seed.png": {
    "atlas": "assets/atlases/farming-herb_seeds-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/herb_seeds/brightmaw_seed.png": {
    "atlas": "assets/atlases/farming-herb_seeds-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/herb_seeds/crownwort_seed.png": {
    "atlas": "assets/atlases/farming-herb_seeds-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/herb_seeds/deepvine_seed.png": {
    "atlas": "assets/atlases/farming-herb_seeds-atlas.png",
    "x": 768,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/herb_seeds/dusk_leaf_seed.png": {
    "atlas": "assets/atlases/farming-herb_seeds-atlas.png",
    "x": 1024,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/herb_seeds/emberroot_seed.png": {
    "atlas": "assets/atlases/farming-herb_seeds-atlas.png",
    "x": 1280,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/herb_seeds/glowstem_seed.png": {
    "atlas": "assets/atlases/farming-herb_seeds-atlas.png",
    "x": 1536,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/herb_seeds/green_leaf_seed.png": {
    "atlas": "assets/atlases/farming-herb_seeds-atlas.png",
    "x": 1792,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/herb_seeds/ironbloom_seed.png": {
    "atlas": "assets/atlases/farming-herb_seeds-atlas.png",
    "x": 0,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/herb_seeds/nightvine_seed.png": {
    "atlas": "assets/atlases/farming-herb_seeds-atlas.png",
    "x": 256,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/herb_seeds/sanctum_leaf_seed.png": {
    "atlas": "assets/atlases/farming-herb_seeds-atlas.png",
    "x": 512,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/herb_seeds/stonebark_seed.png": {
    "atlas": "assets/atlases/farming-herb_seeds-atlas.png",
    "x": 768,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/farming/herb_seeds/sunpetal_seed.png": {
    "atlas": "assets/atlases/farming-herb_seeds-atlas.png",
    "x": 1024,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/fishing/raw_blueback.png": {
    "atlas": "assets/atlases/fishing-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/fishing/raw_broadbill.png": {
    "atlas": "assets/atlases/fishing-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/fishing/raw_crimson_char.png": {
    "atlas": "assets/atlases/fishing-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/fishing/raw_mako.png": {
    "atlas": "assets/atlases/fishing-atlas.png",
    "x": 768,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/fishing/raw_river_char.png": {
    "atlas": "assets/atlases/fishing-atlas.png",
    "x": 1024,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/fishing/raw_sand_smelt.png": {
    "atlas": "assets/atlases/fishing-atlas.png",
    "x": 1280,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/fishing/raw_silver_sprat.png": {
    "atlas": "assets/atlases/fishing-atlas.png",
    "x": 1536,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/fishing/raw_skipjack.png": {
    "atlas": "assets/atlases/fishing-atlas.png",
    "x": 1792,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/fishing/raw_spiny_lobster.png": {
    "atlas": "assets/atlases/fishing-atlas.png",
    "x": 0,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/glyphbinding/binding_glyph.png": {
    "atlas": "assets/atlases/glyphbinding-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/glyphbinding/doom_glyph.png": {
    "atlas": "assets/atlases/glyphbinding-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/glyphbinding/entropy_glyph.png": {
    "atlas": "assets/atlases/glyphbinding-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/glyphbinding/flame_glyph.png": {
    "atlas": "assets/atlases/glyphbinding-atlas.png",
    "x": 768,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/glyphbinding/frost_glyph.png": {
    "atlas": "assets/atlases/glyphbinding-atlas.png",
    "x": 1024,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/glyphbinding/sanguine_glyph.png": {
    "atlas": "assets/atlases/glyphbinding-atlas.png",
    "x": 1280,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/glyphbinding/spirit_glyph.png": {
    "atlas": "assets/atlases/glyphbinding-atlas.png",
    "x": 1536,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/glyphbinding/stone_glyph.png": {
    "atlas": "assets/atlases/glyphbinding-atlas.png",
    "x": 1792,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/glyphbinding/storm_glyph.png": {
    "atlas": "assets/atlases/glyphbinding-atlas.png",
    "x": 0,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/glyphbinding/verdant_glyph.png": {
    "atlas": "assets/atlases/glyphbinding-atlas.png",
    "x": 256,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/glyphbinding/vigor_glyph.png": {
    "atlas": "assets/atlases/glyphbinding-atlas.png",
    "x": 512,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/glyphbinding/void_glyph.png": {
    "atlas": "assets/atlases/glyphbinding-atlas.png",
    "x": 768,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/mining/astryx_stone.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/blackiron_ore.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/blackiron_rock.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/deepcoal.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 768,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/deepcoal_rock.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 1024,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/diamond.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 1280,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/emerald.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 1536,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/glimmering_vein.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 1792,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/gold_ore.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 0,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/gold_rock.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 256,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/lustrous_vein.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 512,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/onyx.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 768,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/paleshard_ore.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 1024,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/paleshard_rock.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 1280,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/prismatic_vein.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 1536,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/pyrestone_ore.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 1792,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/pyrestone_rock.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 0,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/radiant_vein.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 256,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/ruby.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 512,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/sapphire.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 768,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/skyiron_ore.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 1024,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/skyiron_rock.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 1280,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/verdantcore_ore.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 1536,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/verdantcore_rock.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 1792,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/voidsteel_ore.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 0,
    "y": 768,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/mining/voidsteel_rock.png": {
    "atlas": "assets/atlases/mining-atlas.png",
    "x": 256,
    "y": 768,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 1024
  },
  "assets/icons/skill_icons/alchemy.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/architecting.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/bounty.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/combat.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 768,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/cooking.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 1024,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/crafting.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 1280,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/farming.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 1536,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/fishing.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 1792,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/gatherer.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 0,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/glyphbinding.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 256,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/husbandry.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 512,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/mining.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 768,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/pilfering.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 1024,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/pyre.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 1280,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/smithing.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 1536,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/woodcutting.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 1792,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/skill_icons/woodworking.png": {
    "atlas": "assets/atlases/skill_icons-atlas.png",
    "x": 0,
    "y": 512,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 768
  },
  "assets/icons/smithing/blackiron_bar.png": {
    "atlas": "assets/atlases/smithing-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/smithing/gold_bar.png": {
    "atlas": "assets/atlases/smithing-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/smithing/paleshard_bar.png": {
    "atlas": "assets/atlases/smithing-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/smithing/pyrestone_bar.png": {
    "atlas": "assets/atlases/smithing-atlas.png",
    "x": 768,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/smithing/skyiron_bar.png": {
    "atlas": "assets/atlases/smithing-atlas.png",
    "x": 1024,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/smithing/verdantcore_bar.png": {
    "atlas": "assets/atlases/smithing-atlas.png",
    "x": 1280,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/smithing/voidsteel_bar.png": {
    "atlas": "assets/atlases/smithing-atlas.png",
    "x": 1536,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/ui_icons/coin_1.png": {
    "atlas": "assets/atlases/ui_icons-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/ui_icons/coin_2.png": {
    "atlas": "assets/atlases/ui_icons-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/ui_icons/coin_3.png": {
    "atlas": "assets/atlases/ui_icons-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/ui_icons/coin_4.png": {
    "atlas": "assets/atlases/ui_icons-atlas.png",
    "x": 768,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/ui_icons/fire.png": {
    "atlas": "assets/atlases/ui_icons-atlas.png",
    "x": 1024,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/ui_icons/time.png": {
    "atlas": "assets/atlases/ui_icons-atlas.png",
    "x": 1280,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/ui_icons/tome_of_echoes.png": {
    "atlas": "assets/atlases/ui_icons-atlas.png",
    "x": 1536,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 256
  },
  "assets/icons/woodcutting/arcanewood_log.png": {
    "atlas": "assets/atlases/woodcutting-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodcutting/arcanewood_tree.png": {
    "atlas": "assets/atlases/woodcutting-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodcutting/common_timber_log.png": {
    "atlas": "assets/atlases/woodcutting-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodcutting/common_timber_tree.png": {
    "atlas": "assets/atlases/woodcutting-atlas.png",
    "x": 768,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodcutting/goldleaf_log.png": {
    "atlas": "assets/atlases/woodcutting-atlas.png",
    "x": 1024,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodcutting/goldleaf_tree.png": {
    "atlas": "assets/atlases/woodcutting-atlas.png",
    "x": 1280,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodcutting/gravewood_log.png": {
    "atlas": "assets/atlases/woodcutting-atlas.png",
    "x": 1536,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodcutting/gravewood_tree.png": {
    "atlas": "assets/atlases/woodcutting-atlas.png",
    "x": 1792,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodcutting/ironwood_log.png": {
    "atlas": "assets/atlases/woodcutting-atlas.png",
    "x": 0,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodcutting/ironwood_tree.png": {
    "atlas": "assets/atlases/woodcutting-atlas.png",
    "x": 256,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodcutting/redgrain_log.png": {
    "atlas": "assets/atlases/woodcutting-atlas.png",
    "x": 512,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodcutting/redgrain_tree.png": {
    "atlas": "assets/atlases/woodcutting-atlas.png",
    "x": 768,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodcutting/softbark_log.png": {
    "atlas": "assets/atlases/woodcutting-atlas.png",
    "x": 1024,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodcutting/softbark_tree.png": {
    "atlas": "assets/atlases/woodcutting-atlas.png",
    "x": 1280,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodworking/arrow_shaft_1.png": {
    "atlas": "assets/atlases/woodworking-atlas.png",
    "x": 0,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodworking/arrow_shaft_2.png": {
    "atlas": "assets/atlases/woodworking-atlas.png",
    "x": 256,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodworking/arrow_shaft_3.png": {
    "atlas": "assets/atlases/woodworking-atlas.png",
    "x": 512,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodworking/arrow_shaft_4.png": {
    "atlas": "assets/atlases/woodworking-atlas.png",
    "x": 768,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodworking/arrow_shaft_5.png": {
    "atlas": "assets/atlases/woodworking-atlas.png",
    "x": 1024,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodworking/blackiron_arrowhead.png": {
    "atlas": "assets/atlases/woodworking-atlas.png",
    "x": 1280,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodworking/pale_shard_arrowhead.png": {
    "atlas": "assets/atlases/woodworking-atlas.png",
    "x": 1536,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodworking/pyrestone_arrowhead.png": {
    "atlas": "assets/atlases/woodworking-atlas.png",
    "x": 1792,
    "y": 0,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodworking/skyiron_arrowhead.png": {
    "atlas": "assets/atlases/woodworking-atlas.png",
    "x": 0,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodworking/verdant_core_arrowhead.png": {
    "atlas": "assets/atlases/woodworking-atlas.png",
    "x": 256,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  },
  "assets/icons/woodworking/voidsteel_arrowhead.png": {
    "atlas": "assets/atlases/woodworking-atlas.png",
    "x": 512,
    "y": 256,
    "w": 256,
    "h": 256,
    "aw": 2048,
    "ah": 512
  }
};
